import React from 'react';
import { ChevronLeftIcon } from 'lucide-react';
export const AddressConfirmation = ({
  userData,
  onUserDataChange,
  onBack,
  onConfirm
}) => {
  const handleSubmit = e => {
    e.preventDefault();
    onConfirm();
  };
  return <div className="flex flex-col p-6 flex-grow" data-id="element-37">
      <div className="flex items-center mb-6" data-id="element-38">
        <button onClick={onBack} className="mr-4" data-id="element-39">
          <ChevronLeftIcon size={24} data-id="element-40" />
        </button>
        <div className="flex-grow flex space-x-2" data-id="element-41">
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-42"></div>
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-43"></div>
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-44"></div>
          <div className="h-1 bg-gray-200 flex-grow rounded-full" data-id="element-45"></div>
          <div className="h-1 bg-gray-200 flex-grow rounded-full" data-id="element-46"></div>
        </div>
      </div>
      <h1 className="text-2xl font-bold mb-2" data-id="element-47">
        Next, let's confirm your address
      </h1>
      <p className="text-gray-700 mb-6" data-id="element-48">
        Please validate your address is correct that we pulled from your ID.
        This should be your primary residence and cannot be a P.O. Box.
      </p>
      <form onSubmit={handleSubmit} data-id="element-49">
        <div className="mb-4" data-id="element-50">
          <label className="block text-gray-700 mb-2" data-id="element-51">Address</label>
          <input type="text" value={userData.address || '999 Mitchel Ave'} onChange={e => onUserDataChange('address', e.target.value)} className="w-full p-3 border border-gray-300 rounded-lg" data-id="element-52" />
        </div>
        <div className="mb-4" data-id="element-53">
          <label className="block text-gray-700 mb-2" data-id="element-54">City</label>
          <input type="text" value={userData.city || 'Lansing'} onChange={e => onUserDataChange('city', e.target.value)} className="w-full p-3 border border-gray-300 rounded-lg" data-id="element-55" />
        </div>
        <div className="flex gap-4 mb-4" data-id="element-56">
          <div className="w-1/2" data-id="element-57">
            <label className="block text-gray-700 mb-2" data-id="element-58">State</label>
            <input type="text" value={userData.state || 'MI'} onChange={e => onUserDataChange('state', e.target.value)} className="w-full p-3 border border-gray-300 rounded-lg" data-id="element-59" />
          </div>
          <div className="w-1/2" data-id="element-60">
            <label className="block text-gray-700 mb-2" data-id="element-61">ZIP</label>
            <input type="text" value={userData.zip || '48917'} onChange={e => onUserDataChange('zip', e.target.value)} className="w-full p-3 border border-gray-300 rounded-lg" data-id="element-62" />
          </div>
        </div>
        <div className="mt-auto" data-id="element-63">
          <button type="submit" className="w-full bg-[#5c5cf5] text-white py-3 rounded-full font-medium" data-id="element-64">
            Confirm
          </button>
        </div>
      </form>
    </div>;
};